<template lang="pug">
v-sheet.grey.lighten-4
  v-list.grey.lighten-4.pb-0.px-0.overflow-auto.rounded.scroll(
    style="border-radius: 6px 6px 0 0"
    max-height="300"
  )
    v-list-item.my-0.white(v-for="task in tasks" :key="task.id").mb-2.mx-2
      v-list-item-icon
        v-icon mdi-book-open-outline
      v-list-item-content {{ task.title }}
      v-list-item-action

        v-btn(
          v-if="task.type === 1"
          :to=`{
            name: 'TaskGptSettings',
            params: { id: task.id },
          }`
          color="primary"
          icon
        )
          v-icon mdi-robot
      v-list-item-action
        v-btn(
          :to=`{
            name: 'TaskEdit',
            params: { id: task.id },
            query: { model: model, id: modelId }
          }`
          color="warning"
          icon
        )
          v-icon mdi-pencil
      v-list-item-action
        v-btn(
          @click="openDetachDialog(task.id, model)"
          icon color="error" title="Удалить задание"
        )
          v-icon mdi-close

    v-alert.mx-2(
      type="info"
      v-if="!tasks.length"
    ) Еще нет ни одного задания
  v-btn(
    style="border-radius: 0 0 6px 6px"
    depressed
    @click="openCreateModal"
    color="secondary"
    secondary
    block
  )
    v-icon(left) mdi-plus
    | Добавить новое задание
</template>

<script>
import ChooseCreateTask from './ChooseCreateTask.vue';

export default {
  props: {
    modelId: {
      type: Number,
      required: true,
    },
    tasks: {
      type: Array,
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
  },
  methods: {
    openCreateModal() {
      this.$modals.show('generic-controller', {
        component: ChooseCreateTask,
        title: 'Создание задания',
        'component-props': {
          taskModel: this.model,
          modelId: this.modelId,
        },
      });
    },
    openDetachDialog(taskId, model) {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.tasks.detachTask(
            taskId, {
              model,
              id: this.modelId,
            },
          );
          this.$emit('detachTask', taskId);
          this.$modals.close();
        },
      });
    },
  },
};
</script>
